import React, { useContext, useState, useEffect } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  FormControl,
  InputGroup,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import { Link } from "react-router-dom";
import Pagination from "../Components/Pagination";
import Config from "../config.json";
import { FiExternalLink } from "react-icons/fi";
import Loading from "./Loading";
import ComponentContext from "../Context";
import translatorPic from "../Images/translatorHeroImg.webp";
import { useHash } from "../lib/hooks";
import Statics from "../Statics";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | پایگاه‌های پشتیبانی شده",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const ACCEPTABLE_HASHES = ["translator-list", "translator-order"];
const Post = props => {
  const { post } = props;

  return (
    <div className="list-Item-container" title={post.description}>
      <div className="metaData-list-Items">
        <div className="metaData-list-item-content">
          <span className="font-weight-bold">{post.title}</span>
        </div>
        <div className="metaData-list-item-icon">
          {post.categories
            ? post.categories.map(cat => (
                <span
                  key={cat.id}
                  className="metaData-item-type translator-item-type">
                  {cat.title}{" "}
                </span>
              ))
            : null}

          <a
            href={post.link}
            target="_blank"
            className="translator-item-web"
            rel="noopener noreferrer">
            <FiExternalLink className="translator-item-web-icon" />
          </a>
        </div>
      </div>
    </div>
  );
};
const Translator = () => {
  const { ApiDriver } = useContext(ComponentContext);
  const context = useContext(ComponentContext);

  const [loadingState, setLoadingState] = useState(Statics.NOT_LOADED);

  const [form_name, set_form_name] = useState("");
  const [form_email, set_form_email] = useState("");
  const [form_phone, set_form_phone] = useState("");
  const [form_head, set_form_head] = useState("");
  const [form_headphone, set_form_headphone] = useState("");
  const [form_organization, set_form_organization] = useState("");
  const [form_faculty, set_form_faculty] = useState("");
  const [form_website, set_form_website] = useState("");
  const [form_description, set_form_description] = useState("");
  const [form_file, set_form_file] = useState("");
  const [pageSize] = useState(10);
  const [filteredTranslators, setFilteredTranslators] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [translators, setTranslators] = useState([]);
  const [send_order, set_send_order] = useState(false);
  const [search_term, set_search_term] = useState("");
  const [search_category, set_search_category] = useState("0");
  const [categories, setCategories] = useState([]);
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const selectedTab = useHash(ACCEPTABLE_HASHES);

  useEffect(() => {
    let filtered = translators;

    if (search_category !== "0") {
      filtered = filtered.filter(trans =>
        trans.categories.some(cat => cat.id.toString() === search_category),
      );
    }

    if (search_term) {
      const searchTermLower = search_term.toLowerCase();
      filtered = filtered.filter(trans =>
        trans.title.toLowerCase().includes(searchTermLower),
      );
    }

    setFilteredTranslators(filtered);
    setCurrentPage(1);
  }, [translators, search_term, search_category]);

  const validateForm = () => {
    let newErrors = {};
    let isValid = true;

    if (!form_name.trim()) {
      newErrors.name = "نام و نام خانوادگی الزامی است";
      isValid = false;
    }

    if (!form_email.trim()) {
      newErrors.email = "آدرس ایمیل الزامی است";
      // isValid = false;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(form_email)) {
      newErrors.email = "فرمت ایمیل نامعتبر است";
      isValid = false;
    }

    if (!form_phone.trim()) {
      newErrors.phone = "شماره تماس الزامی است";
      isValid = false;
    } else if (!/^09\d{9}$/.test(form_phone)) {
      newErrors.phone = "فرمت شماره تماس نامعتبر (مثال: 09123456789)";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const SendOrder = () => {
    if (!validateForm()) return;
    const formData = {};
    formData.fullname = form_name;
    formData.phone = form_phone;
    formData.email = form_email;
    formData.description = form_description;
    formData.head_fullname = form_head;
    formData.head_phone = form_headphone;
    formData.organization = form_organization;
    formData.faculty = form_faculty;
    formData.website = form_website;
    formData.file = form_file;
    set_send_order(true);
    ApiDriver.sendTranslatorsOrder(
      formData,
      (data, meta) => {
        set_send_order(false);
        context.notification("سفارش با موفقیت ثبت شد", "success");
      },
      error => {
        context.notification("مشکلی در ارسال بوجود آمد.", "error");
        set_send_order(false);
        if (error.response?.data?.errors) {
          const serverErrors = error.response.data.errors.reduce((acc, err) => {
            acc[err.field] = err.message;
            return acc;
          }, {});
          setErrors(serverErrors);
        }
      },
    );
  };

  const getTranslators = () => {
    setLoadingState(Statics.LOADING);
    const storedTranslators = sessionStorage.getItem("allTranslators");

    if (storedTranslators) {
      const parsedTranslators = JSON.parse(storedTranslators);
      setTranslators(parsedTranslators);
      setLoadingState(Statics.LOADED);
    } else {
      context.ApiDriver.getTranslators(
        {
          page_size: 1000,
        },
        data => {
          setTranslators(data.data);
          sessionStorage.setItem("allTranslators", JSON.stringify(data.data));
          setLoadingState(Statics.LOADED);
        },
        error => {
          console.log(error);
          setLoadingState(Statics.CAUSED_ERROR);
        },
      );
    }
  };

  const getCats = () => {
    setLoadingState(Statics.LOADING);
    const storedTranslatorsCategories = sessionStorage.getItem(
      "allTranslatorsCategories",
    );

    if (storedTranslatorsCategories) {
      const parsedTranslatorsCategories = JSON.parse(
        storedTranslatorsCategories,
      );
      setCategories(parsedTranslatorsCategories);
      setLoadingState(Statics.LOADED);
    } else {
      context.ApiDriver.getTranslatorCategories(
        {},
        data => {
          setCategories(data.data);
          sessionStorage.setItem(
            "allTranslatorsCategories",
            JSON.stringify(data.data),
          );
          setLoadingState(Statics.LOADED);
        },
        error => {
          console.log(error);
          setLoadingState(Statics.CAUSED_ERROR);
        },
      );
    }
  };

  if (loadingState === Statics.NOT_LOADED) {
    getTranslators();
    getCats();
  }

  return (
    <DocumentMeta {...page_meta}>
      <section className="hero-sample hero-translator">
        <div className="hero-sample-right hero-translator-right">
          <h1>پایگاه‌های پشتیبانی‌شده پژوهیار</h1>
          <p>
            پایگاه‌های پشتیبانی‌شده پژوهیار امکان ذخیره اطلاعات از پایگاه‌های
            اطلاعاتی را میسر می‌کند. در این امکان پس از جستجوی اطلاعات در بانک
            اطلاعاتی از طریق مرورگرهای (Edge ، کروم و فایرفاکس) با کلیک بر روی
            نماد پژوهیار اطلاعات در کتابخانه پژوهیار ذخیره خواهد شد.
          </p>
        </div>
        <div className="hero-sample-left">
          <img src={translatorPic} alt="downloadImg" className="" />
        </div>
      </section>

      <Container className="d-flex flex-column justify-content-center overflow-hidden py-4 text-right">
        <div className="line-height-2 my-3 text-justify">
          <h4>پژوهیار از کدام پایگاه‌های اطلاعاتی پشتیبانی می‌کند؟</h4>
          <p>
            در بخش فهرست پایگاه‌های پشتیبانی‌شده، می‌توانید آدرس اینترنتی و نام
            پایگاه‌های پشتیبانی‌شده را مشاهده کنید. برای دریافت و ذخیره اطلاعات
            از این فهرست، ابتدا{" "}
            <Link to="/extensions">افزونه مرورگر پژوهیار</Link> را نصب کنید.
            برای درخواست پشتیبانی از پایگاه مورد نظر خود، از طریق فرم سفارش
            پایگاه، مشخصات خود را ارسال کنید.{" "}
            <Link to="/help/38">راهنمای سفارش پایگاه پشتیبانی شده</Link> را
            ببینید.
          </p>
        </div>
        <Tabs
          defaultActiveKey={selectedTab}
          className="d-flex justify-content-center w-100 custom-tab-content flex-nowrap justify-content-center mb-5">
          <Tab
            eventKey="translator-list"
            tabClassName="d-flex align-items-center flex-1"
            title={<span className="addon-tabs">پایگاه‌ها</span>}>
            {loadingState === Statics.LOADING ? (
              <div className="pajoohyar-loading">
                <Loading />
              </div>
            ) : null}
            {loadingState === Statics.CAUSED_ERROR ? (
              <div className="error-parent mt-5">
                <p>ارتباط با سرور با مشکل مواجه شد !</p>
                <img
                  className="error-img"
                  src="images/errorPic.webp"
                  width="200px"
                  alt="error-png"
                />
              </div>
            ) : null}
            <div className="d-flex flex-column justify-content-center">
              {loadingState === Statics.LOADED ? (
                <div className=" my-3 mb-5">
                  <Row className="px-2 py-3 metaData-controls py-md-2 w-100 mx-0">
                    <Col xs={12} md={3} className="mb-3 mb-md-0">
                      <Form.Control
                        as="select"
                        value={search_category}
                        onChange={e => set_search_category(e.target.value)}>
                        <option value="0">همه</option>
                        {categories.map(cat => (
                          <option key={cat.id} value={cat.id}>
                            {cat.title}
                          </option>
                        ))}
                      </Form.Control>
                    </Col>
                    <Col xs={12} md={9} className="matadata-serach-col">
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="جستجو..."
                          onChange={e => set_search_term(e.target.value.trim())}
                          value={search_term}
                          onKeyPress={e =>
                            e.key === "Enter" &&
                            set_search_term(e.target.value.trim())
                          }
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                </div>
              ) : null}

              {loadingState === Statics.LOADED ? (
                <>
                  <div className="justify-content-center text-center mataData-list d-flex flex-column w-100">
                    {filteredTranslators.length !== 0
                      ? filteredTranslators
                          .slice(
                            (currentPage - 1) * pageSize,
                            currentPage * pageSize,
                          )
                          .map(post => <Post key={post.id} post={post} />)
                      : "نتیجه ای یافت نشد"}
                  </div>
                  {filteredTranslators.length > pageSize && (
                    <div className="d-flex justify-content-center mx-0 p-4">
                      <Pagination
                        onPageChange={setCurrentPage}
                        currentPage={currentPage}
                        totalCount={filteredTranslators.length}
                        pageSize={pageSize}
                      />
                    </div>
                  )}
                </>
              ) : null}
            </div>
          </Tab>
          <Tab
            eventKey="translator-order"
            tabClassName="d-flex align-items-center flex-1"
            title={<span className="addon-tabs">سفارش پایگاه‌</span>}>
            <div className="mx-0 form-container">
              <div className="">
                <>
                  <Row className="mx-0">
                    <Col
                      md={4}
                      className={`form-floating ${
                        errors.name && "invalid-input2"
                      } `}>
                      <FormControl
                        id="fullname"
                        className={`form-control-lg rounded-3 ${
                          errors.name && "is-invalid"
                        }`}
                        placeholder=" "
                        onChange={e => {
                          set_form_name(e.target.value);
                        }}
                      />
                      <label className="text-secondary">
                        نام و نام خانوادگی
                      </label>
                      {errors.name && (
                        <div className="invalid-feedback d-block">
                          {errors.name}
                        </div>
                      )}
                    </Col>
                    <Col
                      md={4}
                      className={`form-floating ${
                        errors.email && "invalid-input2"
                      } `}>
                      <FormControl
                        id="email"
                        className={`form-control-lg rounded-3 ${
                          errors.email && "is-invalid"
                        }`}
                        placeholder=" "
                        onChange={e => {
                          set_form_email(e.target.value);
                        }}
                      />
                      <label className="text-secondary">آدرس ایمیل</label>
                      {errors.email && (
                        <div className="invalid-feedback d-block">
                          {errors.email}
                        </div>
                      )}
                    </Col>
                    <Col
                      md={4}
                      className={`form-floating ${
                        errors.phone && "invalid-input2"
                      } `}>
                      <FormControl
                        id="phone"
                        className={`form-control-lg rounded-3 ${
                          errors.phone && "is-invalid"
                        }`}
                        placeholder=" "
                        onChange={e => {
                          set_form_phone(e.target.value);
                        }}
                      />
                      <label className="text-secondary">شماره تماس</label>
                      {errors.phone && (
                        <div className="invalid-feedback d-block">
                          {errors.phone}
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row className="mx-0">
                    <Col md={8} className="form-floating mt-3">
                      <FormControl
                        id="head_fullname"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => {
                          set_form_head(e.target.value);
                        }}
                      />
                      <label className="text-secondary">
                        نام و نام خانوادگی سرپرست
                      </label>
                    </Col>
                    <Col md={4} className="form-floating mt-3">
                      <FormControl
                        id="head_phone"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => {
                          set_form_headphone(e.target.value);
                        }}
                      />
                      <label className="text-secondary">
                        شماره تماس سرپرست
                      </label>
                    </Col>
                  </Row>
                  <Row className="mx-0">
                    <Col className="form-floating mt-3">
                      <FormControl
                        id="organization"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => {
                          set_form_organization(e.target.value);
                        }}
                      />
                      <label className="text-secondary">
                        نام سازمان/مجله/کنفرانس/دانشگاه
                      </label>
                    </Col>
                  </Row>
                  <Row className="mx-0">
                    <Col md={4} className="form-floating mt-3">
                      <FormControl
                        id="faculty"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => {
                          set_form_faculty(e.target.value);
                        }}
                      />
                      <label className="text-secondary">نام پایگاه</label>
                    </Col>
                    <Col md={4} className="form-floating mt-3">
                      <FormControl
                        id="website"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => {
                          set_form_website(e.target.value);
                        }}
                      />
                      <label className="text-secondary">آدرس پایگاه</label>
                    </Col>
                    <Col md={4} className="file-upload-wrapper mt-3">
                      <label htmlFor="file" className="custom-file-upload">
                        <i className="fas fa-cloud-upload-alt me-2"></i>
                        {form_file ? form_file.name : "انتخاب فایل"}
                      </label>
                      <Form.Control
                        id="file"
                        className="d-none"
                        type="file"
                        onChange={e => {
                          set_form_file(e.target.files[0]);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="mx-0">
                    <Col className="form-floating form-floating-des mt-3">
                      <Form.Group>
                        <Form.Control
                          id="description"
                          className="form-control-lg rounded-3"
                          as="textarea"
                          rows="3"
                          onChange={e => {
                            set_form_description(e.target.value);
                          }}
                          placeholder=" "
                        />
                        <label className="text-secondary">توضیحات تکمیلی</label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="justify-content-end">
                    <Col md={4}>
                      <Button
                        variant="primary"
                        className="w-100 py-2 rounded-pill fw-bold"
                        disabled={send_order}
                        onClick={SendOrder}>
                        {send_order ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            در حال ارسال...
                          </>
                        ) : (
                          <>ثبت سفارش</>
                        )}
                      </Button>
                    </Col>
                  </Row>
                </>
              </div>
            </div>
          </Tab>
        </Tabs>
      </Container>
    </DocumentMeta>
  );
};

export default Translator;
